import { render } from "./SessionsACorrigerPage.vue?vue&type=template&id=8847568c&ts=true"
import script from "./SessionsACorrigerPage.vue?vue&type=script&lang=ts"
export * from "./SessionsACorrigerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__